const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const getCurrencyFormatter = (): Intl.NumberFormat => {
  return currencyFormatter;
};
